import { Scale } from "lucide-react";

export function MissionIntro() {
  return (
    <>
      <div className="relative rounded-sm overflow-hidden mb-8 border border-zinc-200">
        <img
          src="https://images.unsplash.com/photo-1573164574397-dd250bc8a598?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Black professionals working together — the community BBAP serves"
          className="w-full h-[280px] md:h-[380px] object-cover"
        />
      </div>

      <p className="text-zinc-600 leading-relaxed text-lg mb-4">
        Some people face real, constant challenges just for existing in public — followed in stores, treated
        as suspects in their own neighborhoods, denied basic trust and respect regardless of who they are or
        what they've achieved, simply because of the color of their skin. In this country and around the
        world, this has reached what feels like epidemic proportions. Left unaddressed, this kind of bias can
        escalate all the way to violence.
      </p>
      <p className="text-zinc-600 leading-relaxed mb-4">
        This is the founding reason BBAP exists. At the same time, bias isn't exclusive to one group — anyone
        can experience it, and the same tools apply broadly. BBAP welcomes and serves anyone dealing with
        bias, while never losing sight of the emergency that created it.
      </p>
      <p className="text-zinc-950 font-semibold text-lg mb-4">
        Our mission is equality, evolution, and safety for everyone — treating people the same regardless of
        color, and building real accountability instead of letting bias go unspoken and unresolved.
      </p>
      <p className="text-zinc-600 leading-relaxed mb-16">
        This is not one-sided. BBAP isn't about businesses owned by one race versus another. It's about
        identifying which people and businesses — of any background — treat others with dignity, and which
        don't.
      </p>

      <div className="bg-zinc-950 text-white rounded-sm p-8 md:p-10 mb-16">
        <Scale className="h-8 w-8 text-[#4FD1C5] mb-4" />
        <p className="font-display font-bold text-xl md:text-2xl leading-snug">
          Bias is behavior. Behavior can be documented. Documented behavior becomes data.
          Data becomes accountability. Accountability becomes change.
        </p>
      </div>
    </>
  );
}
